import { Route, Switch, Redirect } from "react-router-dom";
import { isLogin } from "./Helpers/request";
import Myaccount from "./Containers/Pages/Myaccount";
import Register from "./Containers/Pages/Register";
import Productdetails from "./Containers/Shopping/productDetails";
import Invoice from "./Containers/Pages/invoice";
import Cart from "./Containers/Pages/cart";
import Services from "./Containers/Pages/Static/Services";
import Checkout from "./Containers/Pages/checkout";
import customDesigns from "./Containers/Pages/Static/customDesigns";
import Financing from "./Containers/Pages/Static/financing";
import EducationGoldBuying from "./Containers/Pages/Static/education-gold-buying";
import EducationDiamondBuying from "./Containers/Pages/Static/education-diamond-buying";
import EducationJewelryCare from "./Containers/Pages/Static/education-jewelry-care";
import EducationGemstones from "./Containers/Pages/Static/education-gemstones";
import MakeAnAppointment from "./Containers/Pages/make-an-appointment";
import PressMedia from "./Containers/Pages/Static/press-media";
import Charities from "./Containers/Pages/Static/charities";
import Testimonials from "./Containers/Pages/Static/testimonials";
import Contact from "./Containers/Pages/Static/contact";
import ResponsibleSourcing from "./Containers/Pages/Static/responsible-sourcing";
import WarrantyGuarantees from "./Containers/Pages/Static/warranty-and-guarantees";
import MilitaryDiscount from "./Containers/Pages/Static/military-discount";
import Careers from "./Containers/Pages/Static/careers";
import ReturnsExchanges from "./Containers/Pages/Static/returns-and-exchanges";
import PrivacyPolicy from "./Containers/Pages/Static/privacy-policy";
import TermsConditions from "./Containers/Pages/Static/terms-and-conditions";
import MissionVision from "./Containers/Pages/Static/mission-and-vision";
import AdaCompliance from "./Containers/Pages/Static/ada-compliance";
import SellYourJewelry from "./Containers/Pages/Static/sell-your-jewelry";
import Insurance from "./Containers/Pages/Static/insurance";
import GiftGuide from "./Containers/Pages/Static/gift-guide";
import OurStory from "./Containers/Pages/Static/our-story";
import IndianJewelry from "./Containers/Pages/Static/indian-jewelry";
import Blog from "./Containers/Pages/Static/blog";
import { Ordersuccess } from "./Containers/Pages/Static/ordersuccess";
import NoPage from "./Containers/Pages/Static/NoPage";
import Wishlist from "./Containers/Pages/wishlist";
import blogDetails from "./Containers/Pages/Static/blogDetails";
import PressMediaDetails from "./Containers/Pages/Static/press-media-details";
import RingSettings from "./Containers/Shopping/ringsettings";
import RingSettingsDiamonds from "./Containers/Shopping/ringsettings-diamonds";
import RingSettingsDiamondsDetails from "./Containers/Shopping/ringsettings-diamonds-details";
import Gemstones from "./Containers/Shopping/gemstone";
import CompleteRing from "./Containers/Shopping/complete-ring";
import GemstonesDetails from "./Containers/Shopping/gemstone-details";
import EducationalBlog from "./Containers/Pages/Static/EducationalBlog";
import FancyColorDiamond from "./Containers/Shopping/FancyColorDiamond";
import Fancycolordetail from "./Containers/Shopping/fancy-detail";
import FAQ from "./Containers/Pages/Static/faq";
import Productlist from "./Containers/Shopping/productlist";
import Home from "./Containers/Front/Home";
import Education from "./Containers/Education/education";
import Gemstone from "./Containers/Shopping/gemstone";
import GemstoneEducation from "./Containers/Education/gemstone";
import EngagementRingEducation from "./Containers/Education/engagement-ring";
import WeddingRingEducation from "./Containers/Education/wedding-ring";
import FineJewelryEducation from "./Containers/Education/fine-jewelry";
import LooseDiamondEducation from "./Containers/Education/loose-diamonds";
import Watches from "./Containers/Shopping/Watches";
import WatchDetails from "./Containers/Shopping/WatchDetails";
import StudSettings from "./Containers/Shopping/Studbilder/stud-settings";
import StudDiamonds from "./Containers/Shopping/Studbilder/stud-diamonds";
import Studdetails from "./Containers/Shopping/Studbilder/Studdetails";
import StudSettingDiamondsDetails from "./Containers/Shopping/Studbilder/StudSettingDiamondDetails";
import CompleteStud from "./Containers/Shopping/Studbilder/complete-stud";
import CbCustomeDesignPage from "./Containers/Pages/Static/CbCustomeDesignPage";
import CdMetals from "./Containers/Pages/Static/CdMetals";
import CbLabGrown from "./Containers/Pages/Static/CbLabGrown";
import DiamondsStaticPage from "./Containers/Pages/DiamondsLandingPage/DiamondsStaticPage";
import EngagmentStaticPage from "./Containers/Pages/EngagementLandingPage/EngagmentStaticPage";
import WeddingRingStaticPage from "./Containers/Pages/WeddingRingLandingPage/WeddingRingStaticPage";
import FineJeweleryStaticPage from "./Containers/Pages/FineJwelleryLandingPage/FineJeweleryStaticPage";
import DiamondElite from "./Containers/Pages/Static/DiamondElite";
import ReferAfriendProgm from "./Containers/Pages/Static/ReferAfriendProgm";
import EducationCenter from "./Containers/Pages/Static/Education/EducationCenter";
import Diamond_education from "./Containers/Pages/Static/Education/Diamond_education";
import ShippingReturnsPoicy from "./Containers/Pages/Static/ShippingReturnsPoicy";
import TennisBraceletsList from "./Containers/Shopping/tennisBraceletsList";
import BandBuilder from "./Containers/Shopping/BandBuilder";

const Mainrouter = () => {
  if (isLogin) {
    return (
      <Switch>
        <Route path="/account/:value" component={Myaccount} />
        <Route path="/invoice/:order_id" component={Invoice} />
        <Route path="/ringsettings" component={RingSettings} />
        <Route path="/ringsettings/:stone" component={RingSettings} />
        <Route path="/ringsettingdetail/:id/:slug" component={Productdetails} />
        <Route path="/band-builder" component={BandBuilder} />
        <Route path="/gemstones" component={Gemstones} />
        <Route path="/fancy-color-diamond" component={FancyColorDiamond} />
        <Route
          path="/fancy-color-diamond-detail/:stock_no"
          component={Fancycolordetail}
        />
        <Route path="/diamonds" component={RingSettingsDiamonds} />
        <Route path="/watches" component={Watches} />
        <Route path="/diamonds/lab" component={RingSettingsDiamonds} />
        <Route
          path="/diamonds-details/:stock_no"
          component={RingSettingsDiamondsDetails}
        />
        <Route
          path="/gemstone-details/:stock_no"
          component={GemstonesDetails}
        />
        <Route path="/watch-details/:stock_no" component={WatchDetails} />
        <Route path="/complete-diamond-ring" component={CompleteRing} />
        <Route path="/complete-gemstone-ring" component={CompleteRing} />
        <Route path="/complete-fancycolor-ring" component={CompleteRing} />
        <Route path="/search/:search_text" component={Productlist} />
        <Route path="/services" component={Services} />
        <Route path="/cart" component={Cart} />
        <Route path="/checkout-shipping" component={Checkout} />
        {/* <Route path="/custom-design" component={customDesigns} /> */}
        <Route path="/financing" component={Financing} />
        {/* <Route path="/education" component={Education} /> */}
        <Route path="/education-gold-buying" component={EducationGoldBuying} />
        <Route
          path="/education-diamond-buying"
          component={EducationDiamondBuying}
        />
        <Route
          path="/education-jewelry-care"
          component={EducationJewelryCare}
        />
        {/* <Route path="/education-metals" component={EducationMetals} /> */}
        <Route path="/education-gemstones" component={EducationGemstones} />
        {/* <Route path="/education-settings" component={EducationSettings} /> */}
        {/* <Route path="/education-diamonds" component={EducationDiamonds} /> */}
        <Route path="/make-an-appointment" component={MakeAnAppointment} />
        <Route path="/press-media" component={PressMedia} />
        <Route path="/press-media-details/:id" component={PressMediaDetails} />
        <Route path="/charities" component={Charities} />
        <Route path="/testimonials" component={Testimonials} />
        <Route path="/contact" component={Contact} />
        <Route path="/responsible-sourcing" component={ResponsibleSourcing} />
        <Route path="/warranty-and-guarantees" component={WarrantyGuarantees} />
        <Route path="/military-discount" component={MilitaryDiscount} />
        <Route path="/careers" component={Careers} />
        <Route path="/returns-and-exchanges" component={ReturnsExchanges} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/shipping-returns" component={ShippingReturnsPoicy} />
        <Route path="/terms-and-conditions" component={TermsConditions} />
        <Route path="/mission-and-vision" component={MissionVision} />
        <Route path="/ada-compliance" component={AdaCompliance} />
        <Route path="/sell-your-jewelry" component={SellYourJewelry} />
        <Route path="/insurance" component={Insurance} />
        <Route path="/2021-gift-guide" component={GiftGuide} />
        <Route path="/about" component={OurStory} />
        <Route path="/indian-jewelry" component={IndianJewelry} />
        <Route path="/blog" component={Blog} />
        <Route path="/faq" component={FAQ} />
        <Route path="/blog-details/:url" component={blogDetails} />
        <Route path="/educational-blog" component={EducationalBlog} />
        <Route path="/custom-design" component={CbCustomeDesignPage} />
        <Route path="/metals" component={CdMetals} />
        <Route path="/lab-created-diamonds-atlanta" component={CbLabGrown} />

        <Route path="/diamond" component={DiamondsStaticPage} />
        <Route path="/engagment-rings" component={EngagmentStaticPage} />
        <Route path="/wedding-ring" component={WeddingRingStaticPage} />
        <Route path="/fine-jewelry-page" component={FineJeweleryStaticPage} />
        <Route path="/diamond-elite" component={DiamondElite} />
        <Route path="/refer-a-friend" component={ReferAfriendProgm} />

        <Route path="/education/loosediamonds" component={Diamond_education} />
        <Route path="/education/engagment-ring" component={Diamond_education} />
        <Route path="/education/wedding-ring" component={Diamond_education} />
        <Route path="/education/fine-jewelery" component={Diamond_education} />
        <Route path="/education" component={EducationCenter} />

        <Route
          path="/wishlist"
          render={() => <Redirect to="/account/wishlist" />}
        />
        <Route path="/productdetail/:slug" component={Productdetails} />
        <Route
          path="/ordersuccess/:order_id/:order_no/:txn_id"
          component={Ordersuccess}
        />
        <Route
          path="/jewelry/:listcategory/:subcategory"
          component={Productlist}
        />
        <Route path="/jewelry/:listcategory" component={Productlist} />
        <Route path="/tennis-bracelets" component={TennisBraceletsList} exact />

        {/* stud_builder_routes */}

        <Route path="/stud-settingdetail/:id/:slug" component={Studdetails} />
        <Route
          path="/stud-diamonds-details/:pairId"
          component={StudSettingDiamondsDetails}
        />
        <Route path="/stud-settings" component={StudSettings} />
        <Route path="/stud-settings/:stone" component={StudSettings} />
        <Route path="/stud-diamonds" component={StudDiamonds} />
        <Route path="/stud-diamonds/lab" component={StudDiamonds} />
        <Route path="/complete-diamond-stud" component={CompleteStud} />
        {/* stud_builder_routes */}

        <Route path="*" exact={true} component={NoPage} />
      </Switch>
    );
  } else {
    return (
      <Switch>
        <Route path="/account/:value" component={Home} />
        <Route path="/invoice/:order_id" component={Home} />
        <Route path="/ringsettings" component={RingSettings} />
        <Route path="/ringsettings/:stone" component={RingSettings} />
        <Route path="/ringsettingdetail/:id/:slug" component={Productdetails} />
        <Route path="/band-builder" component={BandBuilder} />
        <Route path="/gemstones" component={Gemstones} />
        <Route path="/fancy-color-diamond" component={FancyColorDiamond} />
        <Route
          path="/fancy-color-diamond-detail/:stock_no"
          component={Fancycolordetail}
        />
        <Route path="/diamonds" component={RingSettingsDiamonds} />
        <Route path="/watches" component={Watches} />
        <Route path="/diamonds/lab" component={RingSettingsDiamonds} />
        <Route
          path="/diamonds-details/:stock_no"
          component={RingSettingsDiamondsDetails}
        />
        <Route path="/watch-details/:stock_no" component={WatchDetails} />
        <Route
          path="/gemstone-details/:stock_no"
          component={GemstonesDetails}
        />
        <Route path="/complete-diamond-ring" component={CompleteRing} />
        <Route path="/complete-gemstone-ring" component={CompleteRing} />
        <Route path="/complete-fancycolor-ring" component={CompleteRing} />
        <Route path="/search/:search_text" component={Productlist} />
        <Route path="/services" component={Services} />
        <Route path="/register" component={Register} />
        <Route path="/cart" component={Cart} />
        <Route path="/checkout-shipping" component={Checkout} />
        {/* <Route path="/custom-design" component={customDesigns} /> */}
        <Route path="/financing" component={Financing} />
        {/* <Route path="/education" component={Education} /> */}
        <Route path="/education-gold-buying" component={EducationGoldBuying} />
        <Route
          path="/education-diamond-buying"
          component={EducationDiamondBuying}
        />
        <Route
          path="/education-jewelry-care"
          component={EducationJewelryCare}
        />
        {/* <Route path="/education-metals" component={EducationMetals} /> */}
        {/* <Route path="/education-gemstones" component={EducationGemstones} />
            <Route path="/education-settings" component={EducationSettings} /> */}
        {/* <Route path="/education-diamonds" component={EducationDiamonds} /> */}
        <Route path="/make-an-appointment" component={MakeAnAppointment} />
        <Route path="/press-media" component={PressMedia} />
        <Route path="/press-media-details/:id" component={PressMediaDetails} />
        <Route path="/charities" component={Charities} />
        <Route path="/testimonials" component={Testimonials} />
        <Route path="/contact" component={Contact} />
        <Route path="/responsible-sourcing" component={ResponsibleSourcing} />
        <Route path="/warranty-and-guarantees" component={WarrantyGuarantees} />
        <Route path="/military-discount" component={MilitaryDiscount} />
        <Route path="/careers" component={Careers} />
        <Route path="/returns-and-exchanges" component={ReturnsExchanges} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/shipping-returns" component={ShippingReturnsPoicy} />
        <Route path="/terms-and-conditions" component={TermsConditions} />
        <Route path="/mission-and-vision" component={MissionVision} />
        <Route path="/ada-compliance" component={AdaCompliance} />
        <Route path="/sell-your-jewelry" component={SellYourJewelry} />
        <Route path="/insurance" component={Insurance} />
        <Route path="/2021-gift-guide" component={GiftGuide} />
        <Route path="/about" component={OurStory} />
        <Route path="/indian-jewelry" component={IndianJewelry} />
        <Route path="/blog" component={Blog} />
        <Route path="/faq" component={FAQ} />
        <Route path="/blog-details/:url" component={blogDetails} />
        <Route path="/educational-blog" component={EducationalBlog} />
        <Route path="/custom-design" component={CbCustomeDesignPage} />
        <Route path="/metals" component={CdMetals} />
        <Route path="/lab-created-diamonds-atlanta" component={CbLabGrown} />
        <Route path="/diamond" component={DiamondsStaticPage} />
        <Route path="/engagment-rings" component={EngagmentStaticPage} />
        <Route path="/wedding-ring" component={WeddingRingStaticPage} />
        <Route path="/fine-jewelry-page" component={FineJeweleryStaticPage} />
        <Route path="/diamond-elite" component={DiamondElite} />
        <Route path="/refer-a-friend" component={ReferAfriendProgm} />
        <Route path="/wishlist" component={Wishlist} />
        <Route path="/productdetail/:slug" component={Productdetails} />
        <Route
          path="/ordersuccess/:order_id/:order_no/:txn_id"
          component={Ordersuccess}
        />
        <Route
          path="/jewelry/:listcategory/:subcategory"
          component={Productlist}
        />
        <Route path="/jewelry/:listcategory" component={Productlist} />
        <Route path="/tennis-bracelets" component={TennisBraceletsList} exact />
        <Route
          path="/education/gemstone-education"
          component={GemstoneEducation}
        />
        <Route
          path="/education/engagement-ring-education"
          component={EngagementRingEducation}
        />
        <Route
          path="/education/wedding-ring-education"
          component={WeddingRingEducation}
        />
        <Route
          path="/education/fine-jewelry-education"
          component={FineJewelryEducation}
        />
        <Route
          path="/education/loose-diamonds-education"
          component={LooseDiamondEducation}
        />
        {/* <Route path="/education" exact component={Education} /> */}

        <Route path="/education/loosediamonds" component={Diamond_education} />
        <Route path="/education/engagment-ring" component={Diamond_education} />
        <Route path="/education/wedding-ring" component={Diamond_education} />
        <Route path="/education/fine-jewelery" component={Diamond_education} />
        <Route path="/education" component={EducationCenter} />

        {/* stud_builder_routes */}
        <Route
          path="/stud-diamonds-details/:pairId"
          component={StudSettingDiamondsDetails}
        />
        <Route path="/complete-diamond-stud" component={CompleteStud} />
        <Route path="/stud-settingdetail/:id/:slug" component={Studdetails} />
        <Route path="/stud-settings" component={StudSettings} />
        <Route path="/stud-settings/:stone" component={StudSettings} />
        <Route path="/stud-diamonds" component={StudDiamonds} />
        <Route path="/stud-diamonds/lab" component={StudDiamonds} />
        {/* stud_builder_routes */}

        <Route path="*" exact={true} component={NoPage} />
      </Switch>
    );
  }
};

export default Mainrouter;
